import React, { useState, useEffect } from "react";
import { Loading, Modal, Text, Textarea, Button as NextButton } from '@nextui-org/react';
import { Delete } from 'react-iconly';
import { useSelector } from "react-redux";

import { secureFetch } from "../../lib/api";
import { success, warning, error } from "../../lib/userAlerts";
import { mstore } from "../../store";
import endpoint from "../../config/endpoint.json";

const CannedDriverMessages = ({ isBrokerShipmentManagement }) => {
  const [state, setState] = useState({
    cannedMessageList: [],
    cannedMessageListc: [],
    addCannedMessage: false,
    loading: false,
    loadinge: false,
    addNewCannedMessage: "",
    fetching: true,
    addMessageName: "",
    deletingId: null
  });

  const Access = useSelector(state => state.navigation.Access);
  const clientId = useSelector(state => state.client?.id || mstore.getPath(["user", "company_id"]));

  const getCannedMessageList = async () => {
    try {
      const [ok, status, json] = await secureFetch(endpoint.fetchCannedMessage, {
        isBrokerShipmentManagement
      });
      
      if (ok) {
        setState(prev => ({
          ...prev,
          cannedMessageList: json.cannedMessage,
          loading: false,
          fetching: false,
          cannedMessageListc: JSON.parse(JSON.stringify(json.cannedMessage))
        }));
      } else {
        error("Oops! error occurred during fetching message list!");
      }
    } catch (err) {
      error("Oops! error occurred during fetching message list!");
    }
  };

  useEffect(() => {
    getCannedMessageList();
  }, [clientId]);

  const addCannedMessage = async () => {
    setState(prev => ({ ...prev, loading: true }));
    try {
      const [ok, status, json] = await secureFetch(endpoint.addNewCannedMessage, {
        message: state.addMessageName,
        isBrokerShipmentManagement
      });

      if (ok) {
        success(json.message);
        await getCannedMessageList();
        setState(prev => ({ 
          ...prev, 
          loading: false, 
          addMessageName: "",
          addCannedMessage: false 
        }));
      } else {
        error("Oops! error occurred during add new message!");
      }
    } catch (err) {
      error("Oops! error occurred during add new message!");
    }
  };

  const deleteMessage = async (obj) => {
    setState(prev => ({ ...prev, deletingId: obj.id }));
    try {
      const [ok, status, json] = await secureFetch(endpoint.deleteCannedMessage, { 
        messageId: obj.id 
      });

      if (ok) {
        await getCannedMessageList();
        success(json.message);
        setState(prev => ({
          ...prev,
          deletingId: null
        }));
      } else {
        error("Oops! error occurred while deleting the canned message!");
        setState(prev => ({
          ...prev,
          deletingId: null
        }));
      }
    } catch (err) {
      error("Oops! error occurred while deleting the canned message!");
      setState(prev => ({
        ...prev,
        deletingId: null
      }));
    }
  };

  const renderUserRow = (obj, idx) => (
    <div 
      key={idx} 
      className="flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 mb-3 group"
    >
      <div className="flex-1 text-gray-700">
        {obj.message}
      </div>
      <NextButton
        ghost
        auto
        color="error"
        onClick={() => deleteMessage(obj)}
        icon={state.deletingId === obj.id ? <Loading size="sm" color="currentColor" /> : <Delete fill="currentColor" />}
        className={`hover:bg-red-50 transition-colors duration-200 ${
          state.deletingId === obj.id ? 'opacity-50 cursor-not-allowed' : ''
        }`}
        disabled={state.deletingId === obj.id}
      >
        <Text color="currentColor">
          {state.deletingId === obj.id ? 'Deleting...' : 'Delete'}
        </Text>
      </NextButton>
    </div>
  );

  if (Access.allow_broker_push_notification !== 1 && isBrokerShipmentManagement) {
    return (
      <div role="alert" className="max-w-2xl mx-auto mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg shadow-sm">
        <div className="flex items-center space-x-3">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <span className="text-yellow-800">Please subscribe to <b>Push Notification</b> feature</span>
        </div>
      </div>
    );
  }

  if (Access.allow_broker_push_notification !== 1) {
    return null;
  }

  if (Access.allow_broker_push_notification !== 1) {
    return null;
  }

  return (
    <div className="mt2 w-100">
      {state.fetching && (
        <div className="flex justify-center mt6">
          <Loading size="md">Fetching your canned messages..</Loading>
        </div>
      )}

      <div>
        {!state.fetching && state.cannedMessageList.length !== 0 && (
          <div className="ml2 mt3 mr2 bg-white p-4 border-2 border-dotted rounded-xl shadow-lg">
            <div className="flex justify-between mb4 border-b">
              <div className="f4 mb2 text-xl font-semibold" style={{ paddingTop: "10px" }}>
                {isBrokerShipmentManagement 
                  ? "Canned Driver Messages (For Carrier Drivers, you may work with as a Broker)"
                  : "Canned Driver Messages (Applicable for your Own Drivers, Free Users)"
                }
              </div>
              <NextButton
                  auto
                  color="primary"
                  className="hover:bg-blue-600 transition-colors duration-200"
                  onClick={() => setState(prev => ({ 
                    ...prev, 
                    addCannedMessage: !prev.addCannedMessage 
                  }))}
                >
                  <Text color="white">Create Message</Text>
                </NextButton>
            </div>

            <table className="flex flex-column w-100 pr2">
              <tr className="flex justify-around pb3">
                <th className="f5 flex flex-start items-center h2" style={{ width: "100%" }}>
                  Message
                </th>
              </tr>
              <tbody>
                {state.cannedMessageList.map((obj, idx) => renderUserRow(obj, idx))}
              </tbody>
            </table>
          </div>
        )}

        <Modal
          closeButton
          preventClose
          aria-labelledby="Add Message"
          open={state.addCannedMessage}
          onClose={() => setState(prev => ({ ...prev, addCannedMessage: false }))}
          className="max-w-3xl"
        >
          <Modal.Header>
            <Text id="modal-title" size={20} className="font-semibold">
              Add New Message
            </Text>
          </Modal.Header>
          <Modal.Body>
            <Textarea
              onChange={(e) => setState(prev => ({ ...prev, addMessageName: e.target.value }))}
              value={state.addMessageName}
              rows={5}
              label="Message"
              placeholder="Enter your message here..."
              className="w-full"
            />
          </Modal.Body>
          <Modal.Footer>
            <NextButton
              auto
              disabled={state.loading}
              color="primary"
              className="hover:bg-blue-600 transition-colors duration-200"
              onClick={() => {
                if (!state.addMessageName) {
                  warning("Please enter a message and then click submit.");
                  return;
                }

                if (state.cannedMessageList.some(item => item.message === state.addMessageName.trim())) {
                  warning("This message already exists.");
                  return;
                }

                addCannedMessage();
              }}
            >
              {state.loading ? (
                <div className="flex items-center space-x-2">
                  <Loading size="sm" color="white" />
                  <Text color="white">Creating...</Text>
                </div>
              ) : (
                <Text color="white">Submit</Text>
              )}
            </NextButton>
          </Modal.Footer>
        </Modal>
      </div>

      {!state.fetching && state.cannedMessageList.length === 0 && (
        <div className="bg-white ml2 mt-4 mr2 p-6 text-center border-2 border-dotted" style={{ paddingLeft: "20px" }}>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            {isBrokerShipmentManagement 
              ? "Canned Driver Messages (For Carrier Drivers)"
              : "Canned Driver Messages (For Your Drivers)"
            }
          </h2>

          <p className="text-gray-600 mb-6">
            Create quick, reusable messages to communicate with your drivers efficiently.
          </p>

          <NextButton
                auto
                color="primary"
                className="hover:bg-blue-600 transition-colors duration-200"
                onClick={() => setState(prev => ({ 
                  ...prev, 
                  addCannedMessage: !prev.addCannedMessage 
                }))}
              >
                <Text color="white">Create your first message</Text>
              </NextButton>
        </div>
      )}
    </div>
  );
};

export default CannedDriverMessages;